module.exports = __webpack_public_path__ + "img/il.94e3664e.svg";